import EiduInscripcion from "containers/Matricula/Eidu";

export default function EiduPage() {
  return <EiduInscripcion />;
}
